import voucherOrderTransformer from '../../transformers/voucherOrder';
import axios from 'axios';

export default (id, params) => {
  const promise = new Promise((resolve, reject) => {
    axios.patch(process.env.VUE_APP_API_ADMIN_LOCATION + `voucher-orders/${id}`, params).then(
      ({ data }) => {
        if (data.data) {
          data.data = voucherOrderTransformer.fetchForTable(data.data);
        }
        resolve(data.data);
      },
      (error) => {
        reject(error);
      }
    );
  });

  return promise;
};
